
<div class="modal-header border-bottom">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<form [formGroup]="user" id="user-details" (ngSubmit)="onSubmit(user)" class="app-font-regular">
  <div class="modal-header">
    <div class="d-flex justify-content-center1 text-center">
      <h2 class="app-font-bold">{{'HELP_DIALOG.TITLE' | translate}}</h2>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="errorMessage" class="d-flex flex-column align-items-center text-center">
      <div class="m-1 m-error">
        {{errorMessage}}
      </div>
    </div>
    <div class="d-flex flex-column align-items-center text-center help-dialog-item">
      <div class="m-1 bottom-margin width-100">
        <div class="input-wrapper">
          <input type="text" class="app-input" formControlName="firstName" required />
          <label class="label">{{ 'HELP_DIALOG.FIRST_NAME_PC' | translate }}</label>
          <label class="error-label" *ngIf="user.get('firstName').hasError('required') && submitted">{{ 'HELP_DIALOG.FIRST_NAME_REQUIRED' | translate }}</label>
          <label class="error-label" *ngIf="user.get('firstName').hasError('pattern') && submitted">{{ 'HELP_DIALOG.NAME_ERROR' | translate }}</label>
        </div>
      </div>
      <div class="m-1 bottom-margin width-100">
        <div class="input-wrapper">
          <input type="text" class="app-input" formControlName="lastName" required />
          <label class="label">{{ 'HELP_DIALOG.LAST_NAME_PC' | translate }}</label>
          <label class="error-label" *ngIf="user.get('lastName').hasError('required') && submitted">{{ 'HELP_DIALOG.LAST_NAME_REQUIRED' | translate }}</label>
          <label class="error-label" *ngIf="user.get('lastName').hasError('pattern') && submitted">{{ 'HELP_DIALOG.NAME_ERROR' | translate }}</label>
        </div>
      </div>
      <div class="m-1 bottom-margin width-100">
        <div class="input-wrapper">
          <input type="tel" class="app-input" formControlName="idNumber" required maxlength="9" NumbersOnly />
          <label class="label">{{ 'HELP_DIALOG.ID_NUMBER_PC' | translate }}</label>
          <label class="error-label" *ngIf="user.get('idNumber').hasError('required') && submitted">{{ 'HELP_DIALOG.ID_REQUIRED' | translate }}</label>
          <label class="error-label" *ngIf="user.controls['idNumber'].errors?.invalidId === true && submitted && !user.get('idNumber').hasError('required')">{{ 'HELP_DIALOG.ID_ERROR' | translate }}</label>
          
        </div>
      </div>
      <div class="m-1 bottom-margin phone-wrapper border-radius width-100">
        <phone-number style="border-radius: 15px !important;" [customClass]="'help-dialog'" formControlName="phoneNumber" [(isMobile)]="isMobilePhone" (change)="updateValidators($event.target.value)"
          [attr.aria-label]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate" [attr.aria-invalid]="!user.get('phoneNumber').valid &&  submitted">
        </phone-number>
        <div class="m-error" *ngIf="user.get('phoneNumber').hasError('minlength') && submitted">
          {{ 'HELP_DIALOG.TEL_ERROR' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('phoneNumber').hasError('required') && submitted">
          {{ 'HELP_DIALOG.TEL_ERROR' | translate }}
        </div>
        <div class="m-error" *ngIf="user.get('phoneNumber').hasError('pattern') && submitted">
          {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
        </div>
      </div>
      <div>
        <div class="button-wrapper">
          <button type="submit" class="button app-button button-primary">{{"COMMON.SEND"|translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
      <p>{{'HELP_DIALOG.MSG' | translate}}</p>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/help-dialog-recycle/help-dialog-recycle.component.html